/**
 * EditServicesDialog - Dialog to edit service restrictions for a package
 * Extracted from CustomersPage.js
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EditServicesDialog = ({
  open,
  onOpenChange,
  editingPackage,
  services,
  selectedServiceIds,
  setSelectedServiceIds,
  customerDetailsId,
  onSuccess
}) => {
  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/customers/${customerDetailsId}/package-services?package_id=${editingPackage.package_id}`,
        selectedServiceIds,
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      toast.success('Service-Einschränkungen aktualisiert');
      onOpenChange(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error updating package services:', error);
      toast.error(error.response?.data?.detail || 'Fehler beim Aktualisieren');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>🔒 Service-Einschränkungen bearbeiten</DialogTitle>
        </DialogHeader>
        {editingPackage && (
          <div className="space-y-4">
            <div className="bg-teal-50 p-3 rounded-lg">
              <p className="font-medium text-teal-800">{editingPackage.package_name}</p>
              <p className="text-sm text-teal-600">{editingPackage.remaining_points} Punkte verbleibend</p>
            </div>
            
            <div>
              <Label className="text-sm font-medium">Erlaubte Services:</Label>
              <p className="text-xs text-gray-500 mb-2">
                Wählen Sie die Services, für die dieses Paket verwendet werden kann.
                Keine Auswahl = Alle Services erlaubt.
              </p>
              
              <div className="space-y-2 max-h-64 overflow-y-auto border rounded-lg p-3">
                {/* Option für Alle Services */}
                <label className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer border-b pb-3 mb-2">
                  <input
                    type="checkbox"
                    checked={selectedServiceIds.length === 0}
                    onChange={() => setSelectedServiceIds([])}
                    className="rounded"
                  />
                  <span className="text-sm font-medium text-green-700">✓ Alle Services (keine Einschränkung)</span>
                </label>
                
                {/* Einzelne Services */}
                {services.map(service => (
                  <label key={service.id} className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selectedServiceIds.includes(service.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedServiceIds([...selectedServiceIds, service.id]);
                        } else {
                          setSelectedServiceIds(selectedServiceIds.filter(id => id !== service.id));
                        }
                      }}
                      className="rounded"
                    />
                    <span className="text-sm">{service.name}</span>
                    <span className="text-xs text-gray-400">({service.points_cost} Pkt)</span>
                  </label>
                ))}
              </div>
            </div>
            
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                Abbrechen
              </Button>
              <Button onClick={handleSave}>
                Speichern
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditServicesDialog;
